import script from "./DetalharMatricula.vue?vue&type=script&setup=true&lang=js"
export * from "./DetalharMatricula.vue?vue&type=script&setup=true&lang=js"

import "./DetalharMatricula.vue?vue&type=style&index=0&id=66178bc0&scoped=true&lang=css"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-66178bc0"]])

export default __exports__